import { create } from "zustand";

/**
 * Cross-component trigger for the floating Chatwoot panel in AppRailRight.
 * Anywhere in the app can request "open the chat panel at this conversation";
 * AppRailRight subscribes and opens/navigates its embedded Chatwoot iframe.
 */
interface ChatPanelState {
  /** Bumped on each request so the listener effect re-runs even for the same convo. */
  nonce: number;
  accountId: number | null;
  conversationId: number | null;
  openConversation: (accountId: number, conversationId: number) => void;
}

export const useChatPanelStore = create<ChatPanelState>((set) => ({
  nonce: 0,
  accountId: null,
  conversationId: null,
  openConversation: (accountId, conversationId) =>
    set((s) => ({ nonce: s.nonce + 1, accountId, conversationId })),
}));
